import React from "react";
import { useEffect, useState, useCallback } from "react";
import { Button, Modal, Tabs, Tab } from "react-bootstrap";
import Dropzone from "react-dropzone";
import axios from "axios";

import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { Variables } from "../../../Variations/Variations";
import ReactPaginate from "react-paginate";

function ProductGalery(props) {
  const values = [true, "sm-down", "md-down", "lg-down", "xl-down", "xxl-down"];
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [imageDetails, setImageDetails] = useState("");
  const [showImageDetails, setShowImageDetails] = useState(false);

  const [Media, setMedia] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState(Media);
  let NUM_OF_RECORDS = Media.length;
  let LIMIT = 12;
  const offset = currentPage * LIMIT;
  const currentData = filteredData.slice(offset, offset + LIMIT);
  const pageCount = Math.ceil(filteredData.length / LIMIT);

  const onPageChanged = useCallback(
    (event, page) => {
      event.preventDefault();
      setCurrentPage(page);
    },
    [setCurrentPage]
  );
  const navigate = useNavigate();

  function handleImages(e, id, image) {
    var updatedList = [...props.selectedMedia];
    var media = [...props.showingMedia];
    if (e.target.checked) {
      updatedList = [...updatedList, { MediaId: id, Image: image }];
      media = [...media, { MediaId: id, Image: image }];
    } else {
      updatedList = updatedList.filter((item) => item.MediaId != id);
      media = media.filter((item) => item.MediaId != id);
    }
    props.setSelectedMedia(updatedList);
    props.setShowingMedia(media);
  }

  function handleImageDetails(image) {
    setShowImageDetails(true);
    setImageDetails(image);
  }
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = Media.filter((data) => {
      return data.ImageTitle.search(value) != -1;
    });
    setFilteredData(result);
  };
  const handleDrop = async (files) => {
    
    var count = 0;
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let reader = new FileReader();
      if (files[i].size >= 2000000) {
        count = count + 1;
      } else {
        reader.onload = async function () {
          const formData = new FormData();
          formData.append("Image", files[i]);
          try {
            const res = await axios.post(
              Variables.API_URL + "UploadMedia/UploadImageToServer",
              formData
            );
            if (res.data !== "") {
              await fetch(Variables.API_URL + "UploadMedia/InsertMedia", {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  image: res.data,
                  imageTitle: files[i].name.split(".").slice(0, -1).join("."),
                  altText: "",
                  description: "",
                  caption: "",
                }),
              }).then((Response) => {
                if (Response.ok) {
                  fetchMedia();
                } else {
                  toast.error(Response);
                }
              });
            }
          } catch (ex) {
            console.log(ex);
          }
        };
        reader.readAsDataURL(file);
      }
    }

    if (count === 1) {
      var error1 = " Image is not accepted ";
      toast.error(error1);
    } else if (count > 1) {
      var error2 = count + " Images are not accepted ";
      toast.error(error2);
    }
  };

  function fetchMedia() {
    fetch(Variables.API_URL + "UploadMedia/GetMedia", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((Response) => Response.json())
      .then((Result) => {
        setMedia(Result);
        setFilteredData(Result);
      });
  }
  useEffect(() => {
    fetchMedia();
  }, []);

  return (
    <div className="card">
      <div className="card-header">
        <b> Product Gallery</b>
      </div>

      <Button
        className="me-2 btn btn-secondary btn-sm"
        onClick={() => setShow(true)}
      >
        Add Product Images
      </Button>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add images to product gallery</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            defaultActiveKey="Library"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="Upload" title="Upload File">
              <div className="row mt-5">
                <div className="row">
                  <Dropzone
                    onDrop={handleDrop}
                    accept="image/jpeg,image/png,image/jpg,image/svg"
                    style={{ height: 500 }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps({ className: "dropzone" })}>
                        <input {...getInputProps()} />
                        <p style={{ height: 500 }}>
                          Drag'n'drop images, or click to select files
                        </p>
                      </div>
                    )}
                  </Dropzone>
                </div>
                <div className="row">
                  <br />
                </div>
              </div>
            </Tab>
            <Tab eventKey="Library" title="Media Library">
              <div className="col-12">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-3">
                      <input
                        type="search"
                        className="form-control"
                        onChange={(e) => handleSearch(e)}
                        placeholder={"Search media by name"}
                      />
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <div className="col-12">
                {/* Grid */}
                <div className="row">
                  {currentData.map((image) => (
                    <div className="col-2" key={image.MediaId}>
                      <div className="imagecontainer">
                        <div className="form-check">
                          <button
                            className="btn"
                            onClick={() => handleImageDetails(image)}
                          >
                            <img
                              alt="media"
                              className="form-control"
                              src={Variables.API_PUBLISHED + image.Image}
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* Pagination */}
                <div className="d-flex justify-content-center mt-4">
                  <ReactPaginate
                    pageCount={pageCount}
                    onPageChange={({ selected }) => setCurrentPage(selected)}
                    pageRangeDisplayed={4}
                    marginPagesDisplayed={1}
                    previousLabel={null}
                    nextLabel={null}
                    containerClassName="pagination"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    activeClassName="active"
                    breakLabel="..."
                  />
                </div>
              </div>

              <div className="row">
                <div className="card-footer text-right">
                  <button
                    className="btn btn-primary"
                    onClick={() => setShow(false)}
                  >
                    Choose
                  </button>
                </div>
              </div>
              {showImageDetails === true ? (
                <Modal
                  show={showImageDetails}
                  fullscreen={false}
                  onHide={() => setShowImageDetails(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Image Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-12">
                          <label style={{ fontWeight: "bolder" }}>
                            {" "}
                            Image Title :{" "}
                          </label>{" "}
                          {imageDetails.ImageTitle}
                        </div>
                        <div className="col-12">
                          <label style={{ fontWeight: "bolder" }}>
                            {" "}
                            Image Path :{" "}
                          </label>{" "}
                          {imageDetails.Image}
                        </div>
                        <div className="col-12">
                          <label style={{ fontWeight: "bolder" }}>
                            {" "}
                            Uploaded Date :{" "}
                          </label>{" "}
                          {imageDetails.UploadedDate}
                        </div>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              ) : null}
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ProductGalery;
